import React, { useState } from 'react';
import { Col, Row, Tabs } from 'antd';

// Hooks
import styled from 'styled-components';

// Components
import { Container } from '../../components/UI/Base';
import { Table } from '../../components/UI/Table/Table';
import { BreadcrumbMenu } from '../../components/UI/Breadcrumb/BreadcrumbMenu';

import { Translated } from '../../components/UI/Core';
import { useParkingUsageList } from '../../hooks/Parking/useParkingUsageList';
import { ParkingType } from '../../models/enums/ParkingType';

import { BasicIcon } from '../../components/UI/Icon/BasicIcon';

const StyledTabsContainer = styled.div`
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: white;
  margin-top: 20px;
  border-radius: 8px;
  padding-top: 8px;
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav .ant-tabs-tab {
    font-size: 16px;
    margin-left: 10px;
  }
`;

export const ParkingUsagePage = () => {
  const [parkingType, setParkingType] = useState(ParkingType.ParkingUsage.toString());
  const {
    getBreadcrumbMenuProps,
    getParkingUsageDataProps,
    getParkingTransactionDataProps,
    getParkingUsageTableProps,
    getParkingTransactionTableProps,
    getParkingUsageCrudProps,
    getParkingTransactionCrudProps,
  } = useParkingUsageList();

  // Tab items
  const tabItems = [
    {
      label: (
        <span>
          <BasicIcon className="icon icon-chart-pie" style={{ marginRight: 8 }} />
          <Translated id="parking.Usage.tab.title" />
        </span>
      ),
      key: ParkingType.ParkingUsage.toString(),
    },
    {
      label: (
        <span>
          <BasicIcon className="icon icon-transfer" style={{ marginRight: 8 }} />
          <Translated id="parking.Transaction.tab.title" />
        </span>
      ),
      key: ParkingType.ParkingTransaction.toString(),
    },
  ];

  return (
    <>
      <BreadcrumbMenu {...getBreadcrumbMenuProps()} />
      <Container>
        <Row>
          <Col span={24}>
            <StyledTabsContainer>
              <StyledTabs
                activeKey={parkingType.toString()}
                onChange={(value: any) => setParkingType(value)}
                items={tabItems}
              />
              {parkingType.toString() === ParkingType.ParkingUsage.toString() ? (
                <Table
                  updating={false}
                  {...getParkingUsageDataProps()}
                  {...getParkingUsageTableProps()}
                  {...getParkingUsageCrudProps()}
                />
              ) : (
                <Table
                  updating={false}
                  {...getParkingTransactionDataProps()}
                  {...getParkingTransactionTableProps()}
                  {...getParkingTransactionCrudProps()}
                />
              )}
            </StyledTabsContainer>
          </Col>
        </Row>
      </Container>
    </>
  );
};
